import SVGProps from "./SVGProps"

export default function RightArrow({size = 16, strokeColor = "#AAAAAA", strokeWidth = "2"}) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 14L10.6667 8.16667L6 2.33333" stroke={strokeColor} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

RightArrow.propType = SVGProps